"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.solarflare = void 0;
exports.solarflare = {
    router: '0xd3B02Ff30c218c7f7756BA14bcA075Bf7C2C951e',
    masterchef: '0x995da7dfB96B4dd1e2bd954bE384A1e66cBB4b8c',
};
